import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    required,
    SaveButton,
    TopToolbar,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import { hotlineBlocklistFields } from '../hotlineBlocklist.model';
import { useCreateWithRefresh } from '../../hooks/useMutationWithRefresh';
import { 
    validatePhoneNumber, 
    validateNotes, 
    validateHotlineBlocklistCreate 
} from '../utils/hotlineBlocklistValidators';

const HotlineBlocklistCreate = () => {
    const mutationOptions = useCreateWithRefresh('hotline-blocklist', {
        successMessage: 'Phone number added successfully',
    });

    return (
        <Create mutationOptions={mutationOptions}>
            <SimpleForm validate={validateHotlineBlocklistCreate}>
                <Typography variant="h6" gutterBottom>
                    Add Phone Number to Blocklist
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Block a phone number from calling the Texas and/or Tennessee hotlines.
                </Typography>
                
                <TextInput
                    label="Phone Number"
                    source={hotlineBlocklistFields.phoneNumber}
                    validate={validatePhoneNumber}
                    placeholder="e.g., +15551234567, 5551234567, or (555) 123-4567"
                    helperText="Enter in any format - will be normalized automatically"
                    sx={{ width: 400 }}
                />
                
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography variant="subtitle2" gutterBottom>
                        Apply to Hotlines:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <BooleanInput
                            label="Texas Hotline"
                            source={hotlineBlocklistFields.appliesToTx}
                            defaultValue={true}
                        />
                        <BooleanInput
                            label="Tennessee Hotline"
                            source={hotlineBlocklistFields.appliesToTn}
                            defaultValue={true}
                        />
                    </Box>
                </Box>
                
                <TextInput
                    label="Notes"
                    source={hotlineBlocklistFields.notes}
                    validate={validateNotes}
                    multiline
                    rows={4}
                    placeholder="Optional: Add context or reason for blocking this number"
                    sx={{ width: 400 }}
                />
            </SimpleForm>
        </Create>
    );
};

export default HotlineBlocklistCreate; 